__turbopack_context__.v({
  "SubmitButton": "SubmitButton-module-scss-module__HDCiJW__SubmitButton",
});
